module.exports = __webpack_public_path__ + "img/ignis.5697c618.svg";